
export const required = <span style={{color:'red'}}>*</span>